import { render, staticRenderFns } from "./nav-historical-data.vue?vue&type=template&id=de6c98fa&"
import script from "./nav-historical-data.vue?vue&type=script&lang=ts&"
export * from "./nav-historical-data.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports